import { render, staticRenderFns } from "./profile3.vue?vue&type=template&id=18249343&scoped=true&"
import script from "./profile3.vue?vue&type=script&lang=js&"
export * from "./profile3.vue?vue&type=script&lang=js&"
import style0 from "./profile3.vue?vue&type=style&index=0&id=18249343&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "18249343",
  null
  
)

export default component.exports